<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div
        class="d-md-flex d-block align-items-center justify-content-between mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="onExportPdf"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                 <a
  href="javascript:void(0);"
  class="dropdown-item rounded-1"
  @click="onExportExcel"
>
  <i class="ti ti-file-type-xls me-1"></i>Export as Excel
</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="input-icon mb-2 position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input
              type="text"
              class="form-control date-range bookingrange"
              ref="dateRangeInput"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              :class="{ active: isCollapsed }"
              @click="toggleCollapse"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <total-leads />
      <leads-stages />
      <leads-reason />
      <leads-countries />
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import LeadDashboardService from "@/services/crm/lead-dashboard.service";
import { useLeadDashboardStore } from "@/stores/leadDashboardStore";
import { usePipelineStore } from "@/stores/pipelineStore";

const title = "Leads Dashboard";
const text = "Dashboard";
const text1 = "Leads Dashboard";

const isCollapsed = ref(false);
const dateRangeInput = ref(null);

const dash = useLeadDashboardStore();
const pipelineStore = usePipelineStore();

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value;
  document.body.classList.toggle("header-collapse", isCollapsed.value);
}

function toYMD(m) {
  return m.format("YYYY-MM-DD");
}


async function onExportPdf() {
      try {
        const dash = useLeadDashboardStore?.(); // works if exists
        const filters = dash?.filters ? { ...dash.filters } : {};
        await LeadDashboardService.exportPdf(filters);
      } catch (e) {
        console.error(e);
      }
    }


    async function onExportExcel() {
      try {
        const dash = useLeadDashboardStore?.();
        const filters = dash?.filters ? { ...dash.filters } : {};
        await LeadDashboardService.exportExcel(filters);
      } catch (e) {
        console.error(e);
      }
    }

onMounted(async () => {
  // ensure pipeline stages exist for drilldowns
  if (!pipelineStore.items?.length) {
    await pipelineStore.fetchAll({ per_page: 200 });
  }

  const start = moment().subtract(6, "days");
  const end = moment();

  dash.filters.date_from = toYMD(start);
  dash.filters.date_to = toYMD(end);
  await dash.fetchDashboard({}, { force: false });

  if (dateRangeInput.value) {
    const picker = new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      () => {}
    );

    dateRangeInput.value.addEventListener(
      "apply.daterangepicker",
      async (ev) => {
        const p = ev?.detail || picker; // depends on build
        const s = picker.startDate || start;
        const e = picker.endDate || end;

        dash.filters.date_from = toYMD(s);
        dash.filters.date_to = toYMD(e);
        await dash.fetchDashboard({}, { force: false });
      }
    );
  }
});
</script>


